/* eslint-disable @typescript-eslint/ban-types */
import { WatchQueryFetchPolicy } from '@apollo/client';
import { DocumentNode } from 'graphql';

import { GqlVariables } from '@skippay/core/utils/queryUtils';

import { CustomerContext, CustomerContextDomain } from '../types';

export interface DomainSource<TData extends object> {
	kind?: 'query';
	domains: readonly CustomerContextDomain[];
	query: DocumentNode;
	variables?: GqlVariables;
	getVariables?: () => GqlVariables;
	fetchPolicy?: WatchQueryFetchPolicy;
	toModel(data: TData, ctx: Readonly<CustomerContext>): Partial<CustomerContext>;
}

export interface DerivedSource {
	kind: 'derived';
	domains: readonly CustomerContextDomain[];
	toModel(ctx: Readonly<CustomerContext>): Partial<CustomerContext>;
}

export type ContextSource = DomainSource<object> | DerivedSource;

export type ContextAdapter = readonly ContextSource[];

export const isDerivedSource = (source: ContextSource): source is DerivedSource =>
	source.kind === 'derived';
